import React, { useEffect } from "react";
import { observer } from "mobx-react";
import {
    fn_setOrderChannelView, fn_getOrderChannelView, fn_getOrderTypeView,
    fn_getOrderPayView, fn_setOrderRegistList, fn_sendOrderList, fn_initDetailButtonView, fn_orderListClear, fn_checkDlvType
} from "function/FnBodyOrder";

import { fn_bridge_load_shop } from "../../function/FnPosBridge";
import { select_access_token } from "../../http/TokenConn";
import { select_quick_addr, shop_encryption } from "../../http/SettingConn";
import OrderStore from "../../stores/OrderStore";
import LayerStore from "../../stores/LayerStore";
import SearchStore from "../../stores/SearchStore";
import SalesStore from "../../stores/SalesStore";
import ViewStore from "../../stores/ViewStore";
import SettingStore from "../../stores/SettingStore";
import SaleWriteListView from "./item/SaleWriteListView";
import { partnerText, commaString } from "utils/Utils";
import { useDynamicChannelList } from "./hooks/useDynamicChannelList";

const SaleWriteView = observer((props) => {

    const rootStore = {
        orderStore: OrderStore,
        salesStore: SalesStore,
        layerStore: LayerStore,
        searchStore: SearchStore,
        viewStore: ViewStore,
        settingStore: SettingStore
    };


    useEffect(() => {
        fn_bridge_load_shop(rootStore).then(load_yn => {
            select_access_token(rootStore).then(res => {
                select_quick_addr(rootStore).then(res => {
                    shop_encryption(rootStore);
                });
            });
        });
    }, []);

    const searchKeyPress = (e) => {
        const input = document.getElementById("amount");
        const regex = /[^0-9]/g;
        input.value = e.target.value.replace(regex, "");
    };

    const item = (mode, pageNo) => {
        if (mode == "pre" && rootStore.orderStore.getChannelPageCnt > 1) {
            rootStore.orderStore.setChannelPageCnt(rootStore.orderStore.getChannelPageCnt - 1)
        }
        if (mode == "next" && rootStore.orderStore.getChannelPageCnt < pageNo) {
            rootStore.orderStore.setChannelPageCnt(rootStore.orderStore.getChannelPageCnt + 1)
        }
    };

    // 고정 리스트 + 동적 연동 리스트 병합 (훅)
    const rawSetting = rootStore.settingStore.getShopApiSetting || {};
    const { dynamicChannelList, pageNo } = useDynamicChannelList(rawSetting);

    const addList = rootStore.orderStore.getOrderRegistAdd;

    rootStore.layerStore.setLayerLoadingView(false);
    let listVal = rootStore.orderStore.getOrderRegistList;

    global.fn_pos_sale_add_info = function (SHOP_CD, POS_NO, SALE_DATE) {
        rootStore.viewStore.setChangeViewObj('posNo', POS_NO);
        rootStore.searchStore.setSessionKey('shopCd', SHOP_CD);
        rootStore.searchStore.setSessionKey('saleDate', SALE_DATE);

        //초기화
        rootStore.orderStore.setInitOrderRegistAdd();
        rootStore.orderStore.setInitTotalList();
        fn_initDetailButtonView(rootStore);
        return;
    };

    return (
        <>
            {/* <div className="layer_comm layer_common_type_pop layer_open"> */}
            <div className={"layer_comm layer_common_type_pop " + (rootStore.layerStore.getLayerRequiredAlert.view ? 'layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_contenta">
                    <div className="article_alert">
                        <h1>알림</h1>
                        <div className="txt">
                            <p>{rootStore.layerStore.getLayerRequiredAlert.txt}</p>
                        </div>
                        <div className="btn">
                            <button type="button"
                                onClick={event => {
                                    rootStore.layerStore.setLayerRequiredAlert("view", false);
                                    rootStore.layerStore.setLayerRequiredAlert("txt", "");
                                }}
                            >확인</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"layer_comm layer_common_type_pop " + (rootStore.layerStore.getLayerSaleWriteCloseView.view ? 'layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_contenta">
                    <div className="article_alert">
                        <h1>매출 목록 삭제</h1>
                        <dl className="txt">
                            <dt>선택한 매출건을 삭제하시겠습니까?</dt>
                        </dl>
                        <div className="btn btns">
                            <button type="button" className="btn_cancel" onClick={event => {
                                rootStore.layerStore.setLayerSaleWriteCloseView("view", false);
                            }}>취소</button>
                            <button type="button" onClick={event => {
                                rootStore.layerStore.setLayerSaleWriteCloseView("view", false);
                                fn_orderListClear(rootStore, rootStore.layerStore.getLayerSaleWriteCloseView.id)
                            }}>확인</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"layer_comm layer_common_type_pop " + (rootStore.layerStore.getLayerSaleWriteCloseView.confirm ? 'layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_contenta">
                    <div className="article_alert">
                        <h1>안내</h1>
                        <dl className="txt">
                            <dt>배민1, 익스프레스는 배달 매출만 등록 가능합니다.</dt>
                            <dt>배달 주문 매출로 등록하겠습니까?</dt>
                        </dl>
                        <div className="btn btns">
                            <button type="button" className="btn_cancel" onClick={event => {
                                rootStore.layerStore.setLayerSaleWriteCloseView("confirm", false);
                            }}>취소</button>
                            <button type="button" onClick={event => {
                                fn_checkDlvType(rootStore)
                            }}>확인</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="layer_comm layer_common_type layer_open">
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section">
                            <div className="top">
                                <span className="top_txt">매출 임의등록</span>
                            </div>
                            <div className="write">
                                <div className="sale">
                                    <h2>
                                        <strong className="tit">매출정보 입력</strong>
                                        <button type="button" className="btn_refresh" onClick={event => { fn_initDetailButtonView(rootStore) }} >
                                            <span className="ico">조건 초기화</span>
                                        </button>
                                    </h2>
                                    <dl>
                                        <dt>주문채널<strong>*</strong></dt>
                                        <dd className="first">
                                            {
                                                (Array.isArray(dynamicChannelList[rootStore.orderStore.getChannelPageCnt - 1]) && dynamicChannelList[rootStore.orderStore.getChannelPageCnt - 1].length > 0) ?
                                                    dynamicChannelList[rootStore.orderStore.getChannelPageCnt - 1].map((obj, index) => {
                                                        const dispText = obj !== "" ? (partnerText(obj) || obj) : "";

                                                        return (
                                                            <label key={index}
                                                                onClick={event => {
                                                                    event.preventDefault();
                                                                    if (obj !== "") {
                                                                        fn_setOrderChannelView(rootStore, 'channel', obj, dispText, true)
                                                                    }
                                                                }}
                                                            >
                                                                <input type="radio" name="orderChannel" readOnly={true} checked={
                                                                    obj !== "" ?
                                                                        fn_getOrderChannelView(rootStore)[obj] === true ? true : ""
                                                                        : false
                                                                } />
                                                                <span className={obj === "" ? "txt none" : "txt"}>{dispText}</span>
                                                            </label>
                                                        )
                                                    })
                                                    : null
                                            }
                                            <label ><span className={rootStore.orderStore.getChannelPageCnt > 1 ? "preBtn" : "preBtn disabled"} onClick={event => { item("pre", pageNo) }}></span></label>
                                            <label><span className={rootStore.orderStore.getChannelPageCnt < pageNo ? "nextBtn" : "nextBtn disabled"} onClick={event => { item("next", pageNo) }}></span></label>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>주문유형<strong>*</strong></dt>
                                        <dd className="first last">
                                            <label
                                                onClick={event => {
                                                    event.preventDefault();
                                                    fn_setOrderChannelView(rootStore, 'type', 'D', "배달", true)
                                                }}
                                            >
                                                <input type="radio" name="orderChannelType" readOnly={true} checked={fn_getOrderTypeView(rootStore).D === true ? true : ""} />
                                                <span className="txt">배달</span>
                                            </label>
                                            <label
                                                onClick={event => {
                                                    event.preventDefault();
                                                    fn_setOrderChannelView(rootStore, 'type', 'P', "포장", true)
                                                }}
                                            >
                                                <input type="radio" name="orderChannelType" readOnly={true} checked={fn_getOrderTypeView(rootStore).P === true ? true : ""} />
                                                <span className="txt">포장</span>
                                            </label>
                                            <label
                                                onClick={event => {
                                                    event.preventDefault();
                                                    fn_setOrderChannelView(rootStore, 'type', 'O', "매장", true)
                                                }}
                                            >
                                                <input type="radio" name="orderChannelType" readOnly={true} checked={fn_getOrderTypeView(rootStore).O === true ? true : ""} />
                                                <span className="txt">매장</span>
                                            </label>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>결제방법<strong>*</strong></dt>
                                        <dd className="first last">
                                            <label
                                                onClick={event => {
                                                    event.preventDefault();
                                                    fn_setOrderChannelView(rootStore, 'pay', 'prePaid', "(선불)", true)
                                                }}
                                            >
                                                <input type="radio" name="orderChannelPay" readOnly={true} checked={fn_getOrderPayView(rootStore).prePaid === true ? true : ""} />
                                                <span className="txt">선불</span>
                                            </label>
                                            <label
                                                onClick={event => {
                                                    event.preventDefault();
                                                    fn_setOrderChannelView(rootStore, 'pay', 'paidCard', "(후/카)", true)
                                                }}
                                            >
                                                <input type="radio" name="orderChannelPay" readOnly={true} checked={fn_getOrderPayView(rootStore).paidCard === true ? true : ""} />
                                                <span className="txt">후불카드</span>
                                            </label>
                                            <label
                                                onClick={event => {
                                                    event.preventDefault();
                                                    fn_setOrderChannelView(rootStore, 'pay', 'paidCash', "(후/현)", true)
                                                }}
                                            >
                                                <input type="radio" name="orderChannelPay" readOnly={true} checked={fn_getOrderPayView(rootStore).paidCash === true ? true : ""} />
                                                <span className="txt">후불현금</span>
                                            </label>
                                        </dd>
                                    </dl>
                                    <dl className="pay">
                                        <dt className="method">매출금액<strong>*</strong></dt>
                                        <dd className="first btn">
                                            <input className="num" type="text" id="amount"
                                                onChange={event => { searchKeyPress(event); fn_setOrderChannelView(rootStore, 'amount', event.target.value, "금액"); }}
                                                maxLength="7"
                                            /><span className="won" id="won">원</span>
                                            <button type="button" className="add"
                                                onClick={event => {
                                                    event.preventDefault();
                                                    fn_setOrderRegistList(rootStore)
                                                }}
                                            ><span>매출추가</span></button>
                                        </dd>
                                    </dl>
                                    <div className="sub">
                                        <p>• 입력한 매출정보는 1건의 매출로 추가됩니다.</p>
                                        <p>• 매출 임의등록은 한번에 최대 5건까지 가능합니다.</p>
                                        <p>• 매출요약 화면에서 임의등록한 매출은 [새로고침] 후 조회됩니다.</p>
                                        <p>• 임의등록한 매출은 완료건으로 생성되며, 배달매니저 [지난 주문내역]에서 조회할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className="list">
                                    <h2>
                                        <strong className="tit">매출등록 목록</strong>
                                    </h2>
                                    <ul>
                                        {addList.length > 0
                                            ?
                                            addList.map((obj, index) => (
                                                <SaleWriteListView key={index} rootStore={rootStore} obj={obj} />
                                            )) : null
                                        }
                                    </ul>
                                    <div className="total">
                                        <span className="cnt">총 {rootStore.orderStore.getTotalRegistInfo.cnt} 건</span>
                                        <span className="money">{commaString(rootStore.orderStore.getTotalRegistInfo.money)} 원</span>
                                    </div>
                                    <button className="add"
                                        onClick={event => {
                                            event.preventDefault();
                                            fn_sendOrderList(rootStore)
                                        }}
                                    >매출 임의등록</button>
                                </div>
                            </div>
                        </div>
                        <div className="btn_close">
                            <button><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
});

export default SaleWriteView;